<template>
  <v-app id="main">
    <v-content class="el bady" id="content">
      
      <link rel="preload" as="image" href="~/assets/background-images/pretty-sky.jpg">
      <link rel="preload" as="image" href="~/assets/background-images/pretty-waves.jpg">
      <v-container>
        <v-overlay :absolute="absolute" :value="overlay" opacity="1">
          <center>
            <div :class="`${getRandomColor()} lighten-2 pa-4 px-8`" style="border-radius: 25px;">
              <h1>{{getRandomWelcomeMessage()}}</h1>
            </div>
            <v-progress-circular class="mt-12" indeterminate color="primary"></v-progress-circular>
          </center>
        </v-overlay>
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  async mounted() {
    await new Promise(r => setTimeout(r, 3000));
    this.overlay = false;
  },

  methods: {
    getRandomWelcomeMessage() {
      const welcomeMessages = [
        "Hei der 😊",
        "Takk for at du stakk innom ❤️",
        "Håper du har en fin dag 🍏",
        "Ny dag, nye muligheter 🎓",
        "Remember to stretch 🍃",
        "Uten mat og drikke duger helten ikke 🍌",
      ]

      return this.selectRandomlyFromList(welcomeMessages)
    },

    getRandomColor() {
      const colors = [
        "red",
        "green",
        "blue",
        "light-blue",
        "cyan",
        "light-green",
        "orange",
        "deep-orange"
      ]
      
      return this.selectRandomlyFromList(colors)
    },

    selectRandomlyFromList(inputList) {
      return inputList[Math.floor(Math.random() * inputList.length)];
    }
  },

  data() {
    return {
      overlay: true
    };
  }
};
</script>

<style>
#content {
  height: 100%; /* ges Hoehe der Seite -> weitere Hoehenangaben werden relativ hierzu ausgewertet */
  overflow: hidden; /*  hide scrollbars */
  transition: 0.4s;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.el {
  background-size: cover;
  background-blend-mode: lighten;
}

.blurred {
  /* Add the blur effect */
  filter: blur(8px);
}
</style>
